import { render, staticRenderFns } from "./EmailSettingsPage.vue?vue&type=template&id=5dc82f26&lang=pug&"
import script from "./EmailSettingsPage.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettingsPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports